<template>
  <div>
  	<el-button type="primary" class="addBtn" @click="addAdminClick"  v-if="auth_control.have_add_auth">添加管理员</el-button>
    <div class="table-wrap">
    	<el-table
		    :data="tableData"
		    border
		    style="width: 100%">
		    <el-table-column
		      type="index"
		      label="ID"
		      width="60"
		      align="center"
		      :index="handlerSerial"
		    >
		    </el-table-column>
		    <el-table-column
		      prop="name"
		      label="管理员姓名"
		      align="center"
        >
		    </el-table-column>
        <el-table-column
		      prop="mobile"
		      label="手机号"
		      align="center"
        >
		    </el-table-column>
        <el-table-column
		      prop="account"
		      label="账号"
		      align="center"
        >
		    </el-table-column>
		    <el-table-column
		      prop="group.title"
		      label="管理员身份"
		      align="center"
        >
		    </el-table-column>
		    <el-table-column
		      label="操作"
		      align="center"
		      width="160"
        >
         <template slot-scope="scope">
         	  <div class="operation-wrap">
         	    <span class="opration-item" @click="editAdminClick(scope.row)" v-if="auth_control.have_edit_auth">编辑</span>
         	    <span class="opration-item" @click="deleteAdminClick(scope.row)" v-if="auth_control.have_delete_auth">删除</span>
         	  </div>
         </template>
		    </el-table-column>
		  </el-table>
		  <common-pagination
		    :total="total"
	      :page_size="page_size"
		    @size-change="handelPagesizeChange"
		    @page-change="handlePageChange"
		  ></common-pagination>
		</div>
		<common-dialog
	    :title="dialogTitle"
	    :dialogVisible="dialogVisible"
	    @cancel="dialogCancelClick"
	    @confirm="dialogConfirmClick"
	    @dialog-close="dialogClose"
			>
      <div class="dialog-body-wrap">
      	<div v-if="dialogType === 'add' || dialogType === 'edit' ">
      		<el-form
		        :model="form">
		        <el-form-item
		          label="管理员账号"
		          prop="account"
		          :label-width="formLabelWidth">
		          <el-input
		            placeholder="请输入管理员账号"
		            v-model="form.account"
		            autocomplete="off"/>
		        </el-form-item>
		        <el-form-item
		          label="密码"
		          prop="password"
		          :label-width="formLabelWidth">
		          <el-input
		            placeholder="请输入管理员账号密码"
		            v-model="form.password"
		            autocomplete="off"
                v-if="dialogType==='add'"
              />
              <el-input
              placeholder="如果不修改请传空"
              v-model="form.password"
              autocomplete="off"
              v-if="dialogType==='edit'"
              />
		        </el-form-item>
		        <el-form-item
		          label="姓名"
		          prop="name"
		          :label-width="formLabelWidth">
		          <el-input
		            placeholder="请输入管理员姓名"
		            v-model="form.name"
		            autocomplete="off"/>
		        </el-form-item>
		        <el-form-item
		          label="联系方式"
		          prop="user_mobile"
		          :label-width="formLabelWidth">
		          <el-input
		            placeholder="请输入管理员联系方式"
		            v-model="form.user_mobile"
		            autocomplete="off"/>
		        </el-form-item>
		        <el-form-item
		          label="管理员身份"
		          prop="group_id"
		          :label-width="formLabelWidth">
		          <el-select
		            v-model="form.group_id"
		          >
		            <el-option
		              v-for="item in identTable"
		              :key="item.id"
		              :label="item.title"
		              :value="item.id"/>
		          </el-select>
		        </el-form-item>
          </el-form>
      	</div>
      	<div v-if="dialogType ==='delete'">
      	  是否删除管理员？
      	</div>
      </div>
		</common-dialog>
  </div>
</template>

<script>
import CommonPagination from '@/components/CommonPagination';
import CommonDialog from '@/components/CommonDialog';
import { getAuthList, identityOf,  addAdminUser, editAuthUser, delAuthUser } from '@/api/auth';
import { mapState } from 'vuex';

export default {
  data() {
    return {
      tableData: [],
      page_index: '1',  //第几页
  		page_size: '10',
  		total: 0, //总条数
  		dialogVisible: false,
  		dialogTitle: '',
  		dialogType: '',
  		handle_row: {},
      formLabelWidth: '120px',
      form: {
        name: '',
        user_mobile: '',
        account: '',
        password: '',
        group_id: '',
      },
      identTable: [], //身份列表
      auth_control: {
        have_add_auth: false,
        have_edit_auth: false,
        have_delete_auth: false,
      },
      three_rules: [],
    };
  },
  components: {
    CommonPagination,
    CommonDialog
  },
  computed: {
    ...mapState(['operationList'])
  },
  mounted() {
  	this.getAdminList();
  	this.getIdentityList();
    this.handleThreeRules();
  },
  methods: {
  	async getAdminList() {
      let postData = {
      	page_size: this.page_size,
      	page_index: this.page_index
      };
      const { status, data } = await getAuthList(postData);
      if ( status !== 200 ) return
      if (data.char.length) {
      	//后端返回手机号字段和提交时字段不一致
      	data.char.forEach(item => {
      		item.user_mobile = item.mobile;
      	})
      }
      this.tableData = data.char;
      this.total = data.total_data;
      console.log(data, 'admin list')
  	},
  	async getIdentityList() {
      let postData = {
         page_index: 1,
         page_size: 99,
      }
      const { data, status } = await identityOf(postData);
      if ( status !== 200) return
      if (data.char.length) {
      	//身份id是数字类型的 管理员列表对应group_id 是字符串类型。 这一步是把id变为字符串类型已匹配group_id
      	data.char.forEach(item => {
      		item.id += '';
      	})
      }
      this.identTable = data.char;
      console.log(data.char,'identi')
  	},
  	addAdminClick() {
       this.dialogVisible = true;
       this.dialogType = 'add';
       this.dialogTitle = '添加管理员';
  	},
  	editAdminClick(row) {
      let copyRow = JSON.parse(JSON.stringify(row));
      copyRow.password = '';
      this.dialogVisible = true;
      this.form = copyRow;
      this.dialogType = 'edit';
      this.dialogTitle = '编辑管理员';
  	},
  	deleteAdminClick(row) {
      this.form = JSON.parse(JSON.stringify(row));
      this.dialogVisible = true;
      this.dialogType = 'delete';
      this.dialogTitle = '删除管理员';
  	},
  	handelPagesizeChange(size) {
      this.page_size = size;
      this.getAdminList();
  	},
  	handlePageChange(page) {
      this.page_index = page;
      this.getAdminList();
  	},
  	handlerSerial(index) {
      return (this.page_index - 1) * this.page_size + (index + 1);
    },
    dialogCancelClick() {
      this.dialogVisible = false;
    },
    async dialogConfirmClick() {
    	if (this.dialogType === 'add' || this.dialogType === 'edit') {
    		const { name, user_mobile, account, password, group_id } = this.form;
    		if ( !name) {
    			this.$message('管理员姓名不能为空');
    			return;
    		}
    		if ( !user_mobile) {
    			this.$message('手机号不能为空');
    			return;
    		}
    		if (!/^1[34578]\d{9}$/.test(user_mobile)) {
    			this.$message('手机号格式错误');
    			return;
    		}
    		if ( !account) {
    			this.$message('管理员账号不能为空');
    			return;
    		}
    		if ( !password && this.dialogType === 'add') {
    			this.$message('管理员密码不能为空');
    			return;
    		}
    		if ( !group_id) {
    			this.$message('请选择管理员身份');
    			return;
    		}
    	}
    	if (this.dialogType === 'add') {
      	const { status }  = await addAdminUser(this.form);
      	if (status === 200 ) {
      	  this.dialogVisible = false;
      	  return;
      	}
    	}
    	if (this.dialogType === 'edit') {
      	const { status }  = await editAuthUser(this.form);
      	if (status === 200 ) {
      	  this.dialogVisible = false;
      	  return;
      	}
    	}
    	if (this.dialogType === 'delete') {
      	const { status }  = await delAuthUser(this.form.uuid);
      	if (status === 200 ) {
      	  this.dialogVisible = false;
      	  return;
      	}
    	}
    },
    dialogClose() {
      this.dialogVisible = false;
      this.form = {};
      this.getAdminList();
    },
    handleThreeRules() {
      //处理三级权限
      let second_menu_name = this.$route.meta[1].name;
      this.operationList.forEach(item => {
        if (second_menu_name === item.name) {
          this.three_rules = item.operations
        }
      })
      this.three_rules.forEach(item => {
        switch (true) {
          case item.menu_name.indexOf('添加') !== -1:
            this.auth_control.have_add_auth = true;
            break;
          case item.menu_name.indexOf('删除') !== -1:
            this.auth_control.have_delete_auth = true;
            break;
          case item.menu_name.indexOf('编辑') !== -1:
            this.auth_control.have_edit_auth = true;
            break;
        }
      })
     console.log(this.three_rules, 'three rules auth')
    }
  }
};
</script>

<style lang="less" scoped>
@import '~@/assets/styles/variables.less';
.addBtn {
	float: right;
	margin-bottom: 30px;
}
.table-wrap {
	margin-top: 30px;
	.operation-wrap {
		display: flex;
		justify-content: space-around;
		color: @color-text;
		.opration-item {
			cursor: pointer;
		}
	}
}
</style>
